import { useContent } from "../context/ContentContext";
import { PageHeader } from "../components/PageHeader";
import { FileText, ClipboardList, BookOpen, Inbox } from "lucide-react";

const D = {
  daftar: "Informasi yang wajib disediakan dan diumumkan secara berkala\nInformasi yang wajib diumumkan serta-merta (peringatan dini, kejadian bencana)\nInformasi yang tersedia setiap saat (regulasi, data bencana, laporan)",
  perencanaan: "Rencana Strategis (Renstra) BPBD Kayong Utara\nRencana Kerja Tahunan (Renja)\nLaporan Kinerja Instansi Pemerintah (LKjIP)\nLaporan Keuangan dan Penggunaan Dana Penanggulangan Bencana",
  peraturan: "UU No. 24 Tahun 2007 tentang Penanggulangan Bencana\nPP No. 21, 22, 23 Tahun 2008 (Penyelenggaraan, Pendanaan, Peran Lembaga)\nPeraturan Daerah dan Keputusan Kepala Daerah Kayong Utara\nPedoman teknis pelaksanaan penanggulangan bencana (Perka BNPB)",
  mekanisme: "Mengisi formulir permohonan informasi di kantor BPBD atau via email\nMelampirkan fotokopi KTP / identitas resmi pemohon\nMenyebutkan informasi yang diminta dan tujuan penggunaan\nPPID memproses dan memberikan tanggapan tertulis\nJika ditolak, pemohon dapat mengajukan keberatan kepada atasan PPID",
  ppidUraian: "Masyarakat berhak memperoleh informasi publik dari BPBD Kayong Utara. Permohonan informasi dapat diajukan langsung ke kantor BPBD atau melalui email dengan melampirkan identitas dan tujuan penggunaan informasi.",
  ppidEmail: "ppid.bpbd@kayongutarakab.go.id",
  ppidJadwal: "Senin–Jumat, 08.00–15.00 WIB",
  ppidTanggapan: "maksimal 10 hari kerja (+7 hari perpanjangan)",
};

const lines = (s) => s.split("\n").map((x) => x.trim()).filter(Boolean);

export default function InfoPublik() {
  const { c } = useContent();
  const sections = [
    { icon: FileText, color: "text-orange-600", title: "Daftar Informasi Publik", items: lines(c("infopublik_daftar", D.daftar)) },
    { icon: ClipboardList, color: "text-sky-600", title: "Perencanaan & Kinerja", items: lines(c("infopublik_perencanaan", D.perencanaan)) },
    { icon: BookOpen, color: "text-emerald-600", title: "Peraturan Terkait", items: lines(c("infopublik_peraturan", D.peraturan)) },
  ];
  return (
    <div data-testid="info-publik-page">
      <PageHeader title="Informasi Publik & Dokumen" subtitle="Keterbukaan informasi publik sesuai UU No. 14 Tahun 2008 melalui PPID BPBD Kayong Utara" />
      <section className="max-w-7xl mx-auto px-4 py-16 grid md:grid-cols-3 gap-6">
        {sections.map((s) => (
          <div key={s.title} className="hover-lift border border-slate-200 bg-white rounded-xl p-7" data-testid={`dok-${s.title.split(" ")[0].toLowerCase()}`}>
            <s.icon className={`${s.color} mb-4`} size={26} />
            <h2 className="font-heading font-bold text-slate-900 mb-4">{s.title}</h2>
            <ul className="space-y-2.5 text-sm text-slate-600">
              {s.items.map((i) => (
                <li key={i} className="flex gap-2">
                  <span className="text-orange-500 mt-1">▪</span> {i}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </section>
      <section className="bg-slate-950 text-white">
        <div className="max-w-7xl mx-auto px-4 py-16">
          <div className="grid lg:grid-cols-2 gap-10 items-start">
            <div>
              <Inbox className="text-orange-500 mb-4" size={30} />
              <p className="section-label text-orange-500 mb-2">PPID</p>
              <h2 className="font-heading text-lg md:text-2xl font-bold mb-4">Pejabat Pengelola Informasi dan Dokumentasi</h2>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed whitespace-pre-line" data-testid="ppid-uraian">
                {c("ppid_uraian", D.ppidUraian)}
              </p>
              <div className="mt-6 border border-slate-800 rounded-xl p-5 text-sm space-y-2">
                <p><span className="text-slate-500">Jadwal layanan:</span> {c("ppid_jadwal", D.ppidJadwal)}</p>
                <p><span className="text-slate-500">Email PPID:</span> <span className="font-mono">{c("ppid_email", D.ppidEmail)}</span></p>
                <p><span className="text-slate-500">Waktu tanggapan:</span> {c("ppid_tanggapan", D.ppidTanggapan)}</p>
              </div>
            </div>
            <div className="border border-slate-800 rounded-xl p-7">
              <h3 className="font-heading font-bold mb-5">Mekanisme Permohonan Informasi</h3>
              <ol className="space-y-4 text-sm text-slate-300" data-testid="ppid-mekanisme">
                {lines(c("ppid_mekanisme", D.mekanisme)).map((step, i) => (
                  <li key={step} className="flex gap-3">
                    <span className="font-mono text-orange-500 font-bold">{String(i + 1).padStart(2, "0")}</span>
                    {step}
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
